import { render, staticRenderFns } from "./ssoLogin.vue?vue&type=template&id=585b64e1&scoped=true&"
import script from "./ssoLogin.vue?vue&type=script&lang=js&"
export * from "./ssoLogin.vue?vue&type=script&lang=js&"
import style0 from "./ssoLogin.vue?vue&type=style&index=0&id=585b64e1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585b64e1",
  null
  
)

export default component.exports